import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App, { AuthProvider } from './App';
//import './Main.css';  // Импортируем CSS файл
import reportWebVitals from './reportWebVitals';
import "./i18n.js";
import './Mainnav.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider> {/* Оборачиваем App в AuthProvider */}
    <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
